import { useEffect, useState } from "react";

export const useDynamicWatches = (watch, formNamesToWatch) => {
  const [watchedValues, setWatchedValues] = useState({});

  useEffect(() => {
    const updateWatchedValues = () => {
      const newWatchedValues = {};
      formNamesToWatch.forEach((name) => {
        newWatchedValues[name] = watch(name);
      });
      setWatchedValues(newWatchedValues);
    };

    updateWatchedValues();

    const subscription = watch(() => {
      updateWatchedValues();
    });

    return () => subscription.unsubscribe();
  }, [watch, formNamesToWatch]);

  return watchedValues;
};
